import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Styles from '../../Style/Common.module.css';
import { getServicesTypeAPI } from '../../../services/routes.services';
import { Link, useLocation } from "react-router-dom";
import parse from 'html-react-parser';
import constants from '../../../services/constants';
import Loader from "../../Common/PageLoader/LoadingSpinner";
import Sectors from "../../HomePage/Sectors";
import { useSelector } from 'react-redux';
import MenuPath from "../../Common/Header/CurrentPath";
import KeyProjects from "../../HomePage/KeyProjects";
import Breadcrumb from "./BreadCrumb";
const ServicesOverView=()=>{
    //math Path
    const location = useLocation();
    const { menu } = useSelector(state => state.header);
    const currentPageUrl = location.pathname;
    const currentMenuItem = MenuPath(menu, currentPageUrl);
    const BannerImage = currentMenuItem ? currentMenuItem.image : ''; 
    const BannerTitle = currentMenuItem ? currentMenuItem.parentTab : ''; 

    const [projectServices, setProjectServices] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        Promise.all([
            getServicesTypeAPI('Project Services')
        ]).then(([projectRes]) => {
            setProjectServices(projectRes.data.homeserviceimage);
            setLoading(false);
        }).catch(error => {
            console.log(error);
            setLoading(false);
        });
    }, []);
   
    const filteredArray = projectServices.slice(1);
    console.log(filteredArray)
    if (loading) {
        return <Loader />;
    }
    return(
        <div className={'CertificationPage ' + Styles.MSCPage}>
            <div className={Styles.innerBanner + ' ' + Styles.InnerSmallBanner}>
                {BannerImage && <img src={constants.Image_BASE_URL+""+BannerImage} className={Styles.innerBannerimg} />}
                <div className={Styles.innerBannerContent}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Styles.detail}>
                                    <h2>{BannerTitle}</h2>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <Breadcrumb />
            {projectServices &&
                <div className={Styles.projectOverView}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Styles.proContainer}>
                                    <Row>
                                        <Col>
                                            <div className={Styles.imgSide}>
                                                <figure className={Styles.imgBgStyle}>
                                           {projectServices[0]?.innerimage && <img src={`${ constants.Image_BASE_URL}${projectServices[0]?.innerimage}`} alt="Services" width='524' height='341' />}
                                                </figure>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className={Styles.content}>
                                               {projectServices[0]?.text && <h3>{projectServices[0]?.text}</h3>}
                                               {projectServices[0]?.description && <p> {parse(`${projectServices[0]?.description}`)}</p>}
                                              
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            }
            <div className={Styles.projectNeed}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Styles.proContainer}>
                                <div className={Styles.centerAlight}>
                                    <h3>Service Offerings</h3>
                                </div>
                                {filteredArray && 
                                <div className={Styles.needContainer}>
                                 {filteredArray.map((item)=>{
                                    return(
                                    <div className={Styles.needElem}>
                                        <div>
                                            <figure>
                                            {item.imageicon && <img src={`${ constants.Image_BASE_URL}${item.imageicon}`} alt={item.text} width='' height='' />}
                                               
                                            </figure>
                                            {item.text && <h4>{item.text}</h4>}
                                            {item.description && <p> {parse(`${item.description}`)}</p>}
                                        </div>
                                    </div>
                                    )
                                 })
                                    
                                        }
                                  
                                </div>
}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            
        </div>
    )
}

export default ServicesOverView;